var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChrono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.819c-2.948 0-5.779-1.17-7.867-3.258s-3.258-4.913-3.258-7.867 1.17-5.779 3.258-7.867c2.088-2.088 4.913-3.258 7.867-3.258s5.779 1.17 7.867 3.258c2.088 2.088 3.258 4.913 3.258 7.867s-1.17 5.779-3.258 7.867c-2.088 2.088-4.913 3.258-7.867 3.258zM16 3.4c-3.795 0-7.428 1.506-10.111 4.189s-4.189 6.316-4.189 10.111 1.506 7.428 4.189 10.111c2.683 2.683 6.316 4.189 10.111 4.189s7.428-1.506 10.111-4.189c2.683-2.683 4.189-6.316 4.189-10.111s-1.506-7.428-4.189-10.111c-2.683-2.683-6.316-4.189-10.111-4.189zM16.795 9.755h-2.385v9.535l7.544 4.525 1.189-1.952-6.355-3.762v-8.339zM9.451 2.431l-2.030-2.431-7.312 6.116 2.049 2.431 7.292-6.116zM31.884 6.135l-7.305-6.135-2.049 2.431 7.312 6.135 2.049-2.431z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrono);
export default __webpack_public_path__ + "static/media/chrono.27eee83c.svg";
export { ForwardRef as ReactComponent };